import { ColorPalette } from './types';
import {
    black,
    white,
    blue,
    green,
    red,
    navyBlue,
    lightGrayBlue,
    pureBlack,
    whiteSmoke,
    lightBlue,
    yukonGold,
    loadingGrey,
    shuttleGrey,
    paleBlue,
    blackBlue,
    pattensBlue,
    cobaltStoneBlue,
    limeGreen,
    darkGreen,
    pureWhite,
    cyanDarkBlue,
    darkCyanBlue,
    darkGreenShade,
    cyanBlueLight,
    steelBlue,
    lightGrey,
    lightBlue1
} from './color.palette';
import grey from './grey';

const colors: ColorPalette = {
    black,
    white,
    blue,
    green,
    red,
    navyBlue,
    grey,
    lightGrayBlue,
    pureBlack,
    whiteSmoke,
    lightBlue,
    yukonGold,
    loadingGrey,
    shuttleGrey,
    paleBlue,
    blackBlue,
    pattensBlue,
    cobaltStoneBlue,
    limeGreen,
    darkGreen,
    pureWhite,
    cyanDarkBlue,
    darkCyanBlue,
    darkGreenShade,
    cyanBlueLight,
    steelBlue,
    lightGrey,
    lightBlue1
};

export default colors;
